import { useState } from "react";

import { faCircle } from "@fortawesome/pro-solid-svg-icons";

import { Pill } from "src/base-components/Pill";
import { Tooltip } from "src/design-system/Tooltip";
import { assertUnreachable } from "src/utils/typeUtils";

type StatusPillProps = {
  color: "green" | "indigo" | "yellow";
  value: string | number;
  tooltip: {
    title: string;
    body?: React.ReactNode;
  };
};

const getColor = (color: StatusPillProps["color"]) => {
  switch (color) {
    case "green":
      return "text-green-400";
    case "indigo":
      return "text-indigo-400";
    case "yellow":
      return "text-yellow-400";
    default:
      assertUnreachable(color);
      return "text-gray-500";
  }
};

export const ResourceStatusPill: React.FC<StatusPillProps> = ({
  color,
  value,
  tooltip,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <Tooltip
      body={tooltip.body}
      open={isHovered}
      placement="bottom"
      title={tooltip.title}
      asChild
      onOpenChange={setIsHovered}
    >
      <Pill hovered={isHovered} size="base" variant="outlined-white">
        <Pill.Icon color={getColor(color)} icon={faCircle} size="sm" />
        <Pill.Text>{value}</Pill.Text>
      </Pill>
    </Tooltip>
  );
};

export const ResourceStatusPillContainer: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return <div className="[&>*:not(:first-child)]:-ml-1.5">{children}</div>;
};
